import { propPanel as parentPropPanel } from '../text/propPanel';
const getAvailableVariables = (i18nFunc) => [
    { "Variable": "KundennummerB", "AngezeigterName": i18nFunc("schemas.varText.kundennummerB") },
    { "Variable": "NameB", "AngezeigterName": i18nFunc("schemas.varText.betreiberName") },
    { "Variable": "PLZB", "AngezeigterName": i18nFunc("schemas.varText.betreiberPLZ") },
    { "Variable": "AnsprechpartnerB", "AngezeigterName": i18nFunc("schemas.varText.betreiberAnsprechpartner") },
    { "Variable": "OrtB", "AngezeigterName": i18nFunc("schemas.varText.betreiberOrt") },
    { "Variable": "TelefonnummerB", "AngezeigterName": i18nFunc("schemas.varText.betreiberTelefonnummer") },
    { "Variable": "EmailB", "AngezeigterName": i18nFunc("schemas.varText.betreiberEMail") },
    { "Variable": "StrasseB", "AngezeigterName": i18nFunc("schemas.varText.betreiberStrasse") },
    { "Variable": "HausnrB", "AngezeigterName": i18nFunc("schemas.varText.betreiberHausnr") },
    { "Variable": "NameF", "AngezeigterName": i18nFunc("schemas.varText.firmaName") },
    { "Variable": "EmailF", "AngezeigterName": i18nFunc("schemas.varText.firmaEMail") },
    { "Variable": "TelefonF", "AngezeigterName": i18nFunc("schemas.varText.firmaTelefon") },
    { "Variable": "StrasseF", "AngezeigterName": i18nFunc("schemas.varText.firmaStrasse") },
    { "Variable": "PLZF", "AngezeigterName": i18nFunc("schemas.varText.firmaPLZ") },
    { "Variable": "OrtF", "AngezeigterName": i18nFunc("schemas.varText.firmaOrt") },
    { "Variable": "AnsprechpartnerF", "AngezeigterName": i18nFunc("schemas.varText.firmaAnsprechpartner") },
    { "Variable": "HausnrF", "AngezeigterName": i18nFunc("schemas.varText.firmaHausnr") },
    { "Variable": "Pruefgrundlage", "AngezeigterName": i18nFunc("schemas.varText.pruefungGrundlage") },
    { "Variable": "Vertragsnummer", "AngezeigterName": i18nFunc("schemas.varText.pruefungVertragsnummer") },
    { "Variable": "PruefDatum", "AngezeigterName": i18nFunc("schemas.varText.pruefungPruefDatum") },
    { "Variable": "naechstePruefung", "AngezeigterName": i18nFunc("schemas.varText.pruefungNaechstePruef") },
    { "Variable": "HerstellerP", "AngezeigterName": i18nFunc("schemas.varText.objektHersteller") },
    { "Variable": "StandortP", "AngezeigterName": i18nFunc("schemas.varText.objektStandort") },
    { "Variable": "TypP", "AngezeigterName": i18nFunc("schemas.varText.objektTyp") },
    { "Variable": "SeriennummerP", "AngezeigterName": i18nFunc("schemas.varText.objektSeriennummer") },
    { "Variable": "InterneTorNummerP", "AngezeigterName": i18nFunc("schemas.varText.objektInterneNummer") },
    { "Variable": "BaujahrP", "AngezeigterName": i18nFunc("schemas.varText.objektBaujahr") },
    { "Variable": "Steuerung", "AngezeigterName": i18nFunc("schemas.varText.objektSteuerung") },
    { "Variable": "BetriebsartP", "AngezeigterName": i18nFunc("schemas.varText.objektBetriebsart") },
    { "Variable": "BreiteP", "AngezeigterName": i18nFunc("schemas.varText.objektBreite") },
    { "Variable": "HoeheP", "AngezeigterName": i18nFunc("schemas.varText.objektHoehe") },
    { "Variable": "BemerkungP", "AngezeigterName": i18nFunc("schemas.varText.objektBemerkung") },
    { "Variable": "Vorname", "AngezeigterName": i18nFunc("schemas.varText.prueferVorname") },
    { "Variable": "Nachname", "AngezeigterName": i18nFunc("schemas.varText.prueferNachname") },
    { "Variable": "email", "AngezeigterName": i18nFunc("schemas.varText.prueferEMail") },
];
const mapDynamicVariables = (props) => {
    const { rootElement, changeSchemas, activeSchema, i18n, options } = props;
    const mvtSchema = activeSchema;
    const text = mvtSchema.text || '';
    const variables = JSON.parse(mvtSchema.content) || {};
    const variablesChanged = updateVariablesFromText(text, variables);
    const varNames = Object.keys(variables);
    const modal = document.createElement('div');
    modal.style.position = 'fixed';
    modal.style.top = '50%';
    modal.style.left = '50%';
    modal.style.transform = 'translate(-50%, -50%)';
    modal.style.padding = '20px';
    modal.style.paddingTop = '0px';
    modal.style.backgroundColor = 'white';
    modal.style.boxShadow = '0 0 10px rgba(0, 0, 0, 0.5)';
    modal.style.zIndex = '1000';
    modal.style.maxHeight = '80%';
    modal.style.overflowY = 'auto';
    modal.style.width = '400px';
    modal.style.display = 'none';
    modal.style.borderRadius = '8px';
    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    overlay.style.zIndex = '999';
    overlay.style.display = 'none';
    const closeModal = () => {
        modal.style.display = 'none';
        overlay.style.display = 'none';
    };
    overlay.addEventListener('click', closeModal);
    const closeIcon = document.createElement('span');
    closeIcon.innerText = '×';
    closeIcon.style.position = 'absolute';
    closeIcon.style.top = '0';
    closeIcon.style.right = '10px';
    closeIcon.style.cursor = 'pointer';
    closeIcon.style.fontSize = '30px';
    closeIcon.style.color = '#333';
    closeIcon.onclick = () => closeModal();
    modal.appendChild(closeIcon);
    const variableList = document.createElement('ul');
    variableList.style.listStyle = 'none';
    variableList.style.padding = '0';
    variableList.style.margin = '0';
    const avaibleVaraiables = getAvailableVariables(i18n);
    avaibleVaraiables.forEach(variable => {
        const listItem = document.createElement('li');
        listItem.style.display = 'flex';
        listItem.style.alignItems = 'center';
        listItem.style.justifyContent = 'space-between';
        listItem.style.padding = '10px';
        listItem.style.borderBottom = '1px solid #ddd';
        const variableText = document.createElement('span');
        variableText.innerText = `${variable.AngezeigterName}`;
        listItem.appendChild(variableText);
        const copyButton = document.createElement('button');
        copyButton.innerText = i18n('schemas.varText.copy');
        copyButton.style.marginLeft = '10px';
        copyButton.style.padding = '5px 10px';
        copyButton.style.border = 'none';
        copyButton.style.backgroundColor = '#53b2ef';
        copyButton.style.color = 'white';
        copyButton.style.borderRadius = '4px';
        copyButton.style.cursor = 'pointer';
        copyButton.style.position = 'relative';
        copyButton.onclick = async () => {
            await navigator.clipboard.writeText(`{${variable.Variable}}`).then(() => closeModal());
        };
        listItem.appendChild(copyButton);
        variableList.appendChild(listItem);
    });
    const title = document.createElement('h2');
    title.innerText = i18n('schemas.varText.availableVar');
    title.style.marginBottom = '10px';
    const headerBar = document.createElement('div');
    headerBar.style.position = 'sticky';
    headerBar.style.top = '0';
    headerBar.style.backgroundColor = 'white';
    headerBar.style.zIndex = '2';
    headerBar.style.display = 'flex';
    headerBar.style.justifyContent = 'space-between';
    headerBar.style.alignItems = 'center';
    headerBar.appendChild(title);
    headerBar.appendChild(closeIcon);
    modal.appendChild(headerBar);
    modal.appendChild(variableList);
    const openModal = () => {
        modal.style.display = 'block';
        overlay.style.display = 'block';
    };
    const openButton = document.createElement('button');
    openButton.innerText = i18n('schemas.varText.showVar');
    openButton.style.border = 'none';
    openButton.style.width = '100%';
    openButton.style.backgroundColor = '#53b2ef';
    openButton.style.color = 'white';
    openButton.style.borderRadius = '4px';
    openButton.style.cursor = 'pointer';
    openButton.onclick = openModal;
    rootElement.appendChild(openButton);
    document.body.appendChild(overlay);
    document.body.appendChild(modal);
    if (variablesChanged) {
        changeSchemas([
            { key: 'content', value: JSON.stringify(variables), schemaId: activeSchema.id },
            { key: 'variables', value: varNames, schemaId: activeSchema.id }
        ]);
    }
};
export const propPanel = {
    schema: (propPanelProps) => {
        if (typeof parentPropPanel.schema !== 'function') {
            throw Error('Oops, is text schema no longer a function?');
        }
        return {
            ...parentPropPanel.schema(propPanelProps),
            dynamicVariables: {
                type: 'object',
                widget: 'mapDynamicVariables',
                bind: false,
                span: 24
            }
        };
    },
    widgets: { ...parentPropPanel.widgets, mapDynamicVariables },
    defaultSchema: {
        ...parentPropPanel.defaultSchema,
        type: 'varText',
        text: 'Add text here using {} for variables ',
        width: 50,
        height: 15,
        content: '{}',
        variables: [],
    },
};
const updateVariablesFromText = (text, variables) => {
    const regex = /\{([^{}]+)}/g;
    const matches = text.match(regex);
    let changed = false;
    if (matches) {
        for (const match of matches) {
            const variableName = match.replace('{', '').replace('}', '');
            if (!(variableName in variables)) {
                variables[variableName] = variableName.toUpperCase();
                changed = true;
            }
        }
        Object.keys(variables).forEach((variableName) => {
            if (!matches.includes('{' + variableName + '}')) {
                delete variables[variableName];
                changed = true;
            }
        });
    }
    else {
        Object.keys(variables).forEach((variableName) => {
            delete variables[variableName];
            changed = true;
        });
    }
    return changed;
};
//# sourceMappingURL=propPanel.js.map